<template>
  <el-dialog
    title="联系方式"
    :visible.sync="dialogVisible"
    width="500px"
    :before-close="handleClose"
  >
    <div class="contact-overview">
      <!-- 微信 -->
      <div class="contact-item">
        <div class="contact-label">微信</div>
        <div class="contact-value">
          <span class="contact-info">{{ currentWx || '-' }}</span>
          <span v-if="currentWx" :class="['qrcode-status', currentWxQrCode ? 'is-success' : 'is-error']">
            {{ currentWxQrCode ? '已上传二维码' : '未上传二维码' }}
          </span>
          <el-button type="link" @click="handleEditWx">修改</el-button>
        </div>
      </div>
      <!-- 手机 -->
      <div class="contact-item">
        <div class="contact-label">手机</div>
        <div class="contact-value">
          <span class="contact-info">{{ currentPhone || '-' }}</span>
          <el-button type="link" @click="handleEditPhone">修改</el-button>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关 闭</el-button>
    </span>
    <EditWechatDialog ref="editWechatDialog" @success="onWxSuccess" />
    <EditPhoneDialog ref="editPhoneDialog" @success="onPhoneSuccess" />
  </el-dialog>
</template>

<script>
import EditWechatDialog from './EditWechatDialog.vue';
import EditPhoneDialog from './EditPhoneDialog.vue';

export default {
  components: {
    EditWechatDialog,
    EditPhoneDialog
  },
  data() {
    return {
      dialogVisible: false,
      currentWx: '',
      currentPhone: '',
      currentWxQrCode: ''
    }
  },
  methods: {
    method_open(companyName, phone, wx, wxCode) {
      this.currentPhone = phone || '';
      this.currentWx = wx || '';
      this.currentWxQrCode = wxCode || '';
      this.dialogVisible = true;
    },
    handleEditWx() {
      this.$refs.editWechatDialog.method_open(this.currentWx, this.currentWxQrCode);
    },
    handleEditPhone() {
      this.$refs.editPhoneDialog.method_open(this.currentPhone);
    },
    onWxSuccess(data) {
      this.currentWx = data.wx;
      this.currentWxQrCode = data.wxCode || '';
      this.$emit('edit', { wx: data.wx, wxCode: data.wxCode });
    },
    onPhoneSuccess(data) {
      this.currentPhone = data.phone;
      this.$emit('edit', { phone: data.phone });
    },
    handleClose() {
      this.dialogVisible = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.contact-overview {
  .contact-item {
    display: flex;
    align-items: center;
    padding: 16px 0;
    border-bottom: 1px solid #f0f0f0;
    &:last-child {
      border-bottom: none;
    }
    .contact-label {
      width: 60px;
      color: #999;
      flex-shrink: 0;
    }
    .contact-value {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .contact-info {
        font-weight: bold;
        color: #333;
      }
      .qrcode-status {
        font-size: 12px;
        &.is-success {
          color: #67c23a;
        }
        &.is-error {
          color: #f56c6c;
        }
      }
    }
  }
}
</style>
